import { useTranslation } from "react-i18next";

export default function SafetyCenter() {
  const { t } = useTranslation();

  const tips = [
    { icon: "ri-shield-check-line", text: t("home:safety1") },
    { icon: "ri-image-line", text: t("home:safety2") },
    { icon: "ri-scales-3-line", text: t("home:safety3") },
    { icon: "ri-ship-line", text: t("home:safety4") },
  ];

  return (
    <section className="py-16 md:py-20 bg-accent-50/40">
      <div className="container-custom max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            <i className="ri-shield-check-line text-accent-500 mr-2"></i>
            {t("home:safetyTitle", "Safety Center")}
          </h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {tips.map((tip, i) => (
            <div key={i} className="bg-background-50 rounded-2xl p-5 md:p-6 text-center">
              <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center mx-auto mb-3">
                <i className={`${tip.icon} text-accent-600 text-lg`}></i>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">{tip.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}